/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'facebook': {
    width: 512,
    height: 512,
    viewBox: '0 0 49.652 49.652',
    data: '<path pid="0" d="M24.826 0C11.137 0 0 11.137 0 24.826c0 13.688 11.137 24.826 24.826 24.826 13.688 0 24.826-11.138 24.826-24.826C49.652 11.137 38.516 0 24.826 0zM31 25.7h-4.039v14.396h-5.985V25.7h-2.845v-5.088h2.845v-3.291c0-2.357 1.12-6.04 6.04-6.04l4.435.017v4.939h-3.219c-.524 0-1.269.262-1.269 1.386v2.99h4.56L31 25.7z" data-original="#000000" class="active-path" data-old_color="#ffc001" _fill="#ffc001"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/facebook.js